import { BsDownload } from "react-icons/bs";
import { generateIcon, type Translationtype } from "utils";

interface INavigationProps {
  href: string;
  className?: string;
  t: Translationtype;
}

export function DownloadFileBtn({
  href,
  className,
  t,
}: INavigationProps): JSX.Element {
  return (
    <a
      className={`${className || ""} btn btn-primary flex flex-row gap-3`}
      download
      href={href}
    >
      <span>{generateIcon(BsDownload)}</span>
      <span>{t("Buttons.download")}</span>
    </a>
  );
}
